// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.search-area[data-v-b9a4650e] {\n  margin-bottom: 20px;\n}\n.pagination[data-v-b9a4650e] {\n  margin-top: 20px;\n  text-align: right;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
